import { render, staticRenderFns } from "./BannersPagesContainer.vue?vue&type=template&id=09614d72&"
import script from "./BannersPagesContainer.vue?vue&type=script&lang=js&"
export * from "./BannersPagesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports